<p>external-url-support works!</p>
